import React from 'react';
import TopBar from '../components/TopBar';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Contact from '../components/Contact';

const ContactPage = () => {
  return (
    <>
      <TopBar />
      <Navbar />
      <Contact />
      <Footer />
    </>
  );
};

export default ContactPage;
